import React from "react";

import { Formik, Form } from "formik";

import { Button, Typography, Modal } from "clearsense-ui/components";
import { Input } from "clearsense-ui/components/formik";
import { dashboardValidationSchema } from "components/DataConsumption/validations";

const TitleModal = ({
  dashboardDetails,
  showModal,
  setShowModal,
  setDashboardDetails,
  handleSubmit,
}) => (
  <Formik
    enableReinitialize
    initialValues={{ title: dashboardDetails.title }}
    validationSchema={dashboardValidationSchema}
    onSubmit={handleSubmit}
  >
    {formik => (
      <Form>
        <Modal isOpen={showModal} closeButton={false}>
          <Modal.Body>
            <Typography style="h3" className="my-6 font-semibold">
              {dashboardDetails.title
                ? "Update Dashboard"
                : "Create New Dashboard"}
            </Typography>
            <Input
              label="Title*"
              name="title"
              size="large"
              data-cy="dashboard-title-input-field"
            />
          </Modal.Body>
          <Modal.Footer className="space-x-2">
            <Button
              label={dashboardDetails.title ? "Update" : "Create"}
              size="large"
              type="submit"
              onClick={() => formik.submitForm()}
              data-cy="dashboard-submit-button"
            />
            <Button
              style="text"
              label="Cancel"
              size="large"
              onClick={() => {
                setShowModal(false);
                formik.resetForm();
                setDashboardDetails("");
              }}
              data-cy="dashboard-cancel-button"
            />
          </Modal.Footer>
        </Modal>
      </Form>
    )}
  </Formik>
);

export default TitleModal;
